export default __webpack_public_path__ + "d1b70cbfa140b982278450f6ab34de17.svg";